import React, {useEffect, useState, useRef, useLayoutEffect} from "react";
import EmptyState from "../../../components/EmptyState";
import {Skeleton} from "antd-mobile";
import useHistoryControl from "../../../hooks/useHistoryControl";
import {TmsPath} from "../../../enums/TmsNavigatePathEnum";
import {useTmsTaskWaypointList} from "../store/transportStore";
import WayPointCard from "./components/WayPointCard";
import {TmsWaypointWithAddressType} from "../graphql/queries/getTmsPublishedTaskByDriverAccountId";
import TransportLayout from "../layouts/TransportLayout";
import {t} from "../../../i18n";
import PullToRefreshWrapper from "../../../components/PullToRefreshWrapper";

const Body: React.FC = () => {
    const [transportingWayPointDataList, setTransportingWayPointDataList] = useState<TmsWaypointWithAddressType[]>([]);
    const { tmsTaskWaypointList: transportingData, loading, refreshTmsTaskWaypointList } = useTmsTaskWaypointList();
    const mainContainerRef = useRef<HTMLDivElement>(null);

    useHistoryControl(TmsPath.TMS_TRANSPORTING, {
        useReplace: true,
        controlNavButton: false
    });

    useEffect(() => {
        if (transportingData.length > 0) {
            setTransportingWayPointDataList(transportingData);
        } else {
            setTransportingWayPointDataList([]);
        }
    }, [transportingData]);

    const handleRefresh = async () => {
        await refreshTmsTaskWaypointList();
    };

    // 恢复主容器滚动位置
    useLayoutEffect(() => {
        const el = document.getElementById('tms-main-container');
        const y = Number(sessionStorage.getItem('tmsPageScrollTop') || '0');
        if (el && y > 0) {
            el.scrollTo({ top: y, behavior: 'auto' });
            sessionStorage.removeItem('tmsPageScrollTop');
        }
    }, []);

    return (
        <div className="flex flex-col h-screen bg-gray-50 gap-2 p-2" ref={mainContainerRef}>
            <div className="flex-1">
                {loading ? (
                    <div className="flex flex-col h-screen">
                        <Skeleton.Title animated/>
                        <Skeleton.Paragraph lineCount={3} animated/>
                        <Skeleton.Title animated/>
                        <Skeleton.Paragraph lineCount={3} animated/>
                        <Skeleton.Title animated/>
                        <Skeleton.Paragraph lineCount={3} animated/>
                        <Skeleton.Title animated/>
                        <Skeleton.Paragraph lineCount={3} animated/>
                        <Skeleton.Title animated/>
                        <Skeleton.Paragraph lineCount={3} animated/>
                    </div>
                ) : (
                    <PullToRefreshWrapper onRefresh={handleRefresh}>
                        {transportingWayPointDataList.length > 0 ? (
                            <div>
                                {transportingWayPointDataList.map((waypoint, index) => (
                                    <WayPointCard
                                        key={waypoint.taskWayPointId || index}
                                        data={waypoint}
                                    />
                                ))}
                            </div>
                        ) : (
                            <EmptyState description={t('pages.tms.noTransportInfo')}/>
                        )}
                    </PullToRefreshWrapper>
                )}
            </div>
        </div>
    );
};


const transportPage: React.FC = () => {
    return (
        <TransportLayout title={`transporting`}>
            <Body/>
        </TransportLayout>
    );
};

export default transportPage;